(function () {
  function withImageWidth(src, width) {
    if (!src) return src;
    if (src.indexOf('width=') > -1) {
      return src.replace(/width=\d+/i, 'width=' + width);
    }
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  class CkQuantityVariantCards {
    constructor(variantRadios) {
      this.variantRadios = variantRadios;
      this.form = document.forms[this.variantRadios.getAttribute('form')];
      this.variantData = this.getVariantData();
      this.inventoryData = this.getInventoryData();
      this.onChange = this.onChange.bind(this);
      this.onVariantChange = this.onVariantChange.bind(this);
      this.onProductInfoLoaded = this.onProductInfoLoaded.bind(this);
    }

    getVariantData() {
      const jsonNode = this.variantRadios.querySelector('script[type="application/json"]:not([data-ck-inventory])');
      if (!jsonNode) return [];
      try {
        const parsed = JSON.parse(jsonNode.textContent);
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        return [];
      }
    }

    getInventoryData() {
      const jsonNode = this.variantRadios.querySelector('script[data-ck-inventory]');
      if (!jsonNode) return null;
      try {
        return JSON.parse(jsonNode.textContent);
      } catch (e) {
        return null;
      }
    }

    init() {
      if (!this.variantData.length) return;
      if (!this.variantRadios.querySelector('.ck-quantity-variant-input')) return;

      this.variantRadios.addEventListener('change', this.onChange);
      if (this.form) {
        this.form.addEventListener('variant:change', this.onVariantChange);
      }
      document.addEventListener('productInfo:loaded', this.onProductInfoLoaded);

      this.patchNativeVariantAvailability();
      this.applyInitialVariantSelection();
      this.syncCards();
      this.applyBundleVariantBehavior();
    }

    patchNativeVariantAvailability() {
      const nativeVariantData = this.variantRadios.variantData;
      if (!Array.isArray(nativeVariantData) || !this.inventoryData) return;

      const quantityInputs = Array.from(this.variantRadios.querySelectorAll('input.ck-quantity-variant-input'));
      if (!quantityInputs.length) return;

      const firstCard = this.variantRadios.querySelector('.ck-quantity-variant-card[for="' + quantityInputs[0].id + '"]');
      if (!firstCard || firstCard.getAttribute('data-show-per-pair') !== 'false') return;

      const state = this.getOptionState();
      if (state.quantityOptionIndex < 0) return;
      const firstQtyValue = quantityInputs[0].value;

      nativeVariantData.forEach((variant) => {
        if (!variant || !Array.isArray(variant.options)) return;
        if (variant.options[state.quantityOptionIndex] === firstQtyValue) return;

        const singleVariant = this.findVariantForCard(firstQtyValue, variant.options, state.quantityOptionIndex);
        if (!singleVariant) return;

        let available;
        if (singleVariant.inventory_management === 'shopify') {
          const singleQty = Number(this.inventoryData[String(singleVariant.id)]) || 0;
          const itemsNeeded = this.getItemsPerPackageForQuantityValue(variant.options[state.quantityOptionIndex]);
          available = singleQty >= itemsNeeded;
        } else {
          available = !!singleVariant.available;
        }

        variant.available = available;
      });
    }

    applyInitialVariantSelection() {
      const quantityInputs = Array.from(this.variantRadios.querySelectorAll('input.ck-quantity-variant-input'));
      if (!quantityInputs.length || !this.form) return;

      const firstInput = quantityInputs[0];
      const firstCard = this.variantRadios.querySelector('.ck-quantity-variant-card[for="' + firstInput.id + '"]');
      if (!firstCard || firstCard.getAttribute('data-show-per-pair') !== 'false') return;

      let changed = false;
      if (!firstInput.checked) {
        firstInput.checked = true;
        changed = true;
      }

      const state = this.getOptionState();
      const currentVariant = this.findVariantForCard(firstInput.value, state.selectedOptions, state.quantityOptionIndex);
      if (!currentVariant || !this.isVariantInStock(currentVariant)) {
        const availableVariant = this.variantData.find(
          (variant) =>
            variant &&
            Array.isArray(variant.options) &&
            variant.options[state.quantityOptionIndex] === firstInput.value &&
            this.isVariantInStock(variant)
        );
        if (availableVariant) {
          this.selectOptionsForVariant(availableVariant, state.quantityOptionIndex);
          changed = true;
        }
      }

      if (changed) {
        this.variantRadios.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    selectOptionsForVariant(variant, quantityOptionIndex) {
      const optionWrappers = Array.from(this.variantRadios.querySelectorAll('.variant-input-wrapper'));
      optionWrappers.forEach((wrapper) => {
        const optionIndexAttr = wrapper.getAttribute('data-option-index') || '';
        const optionIndex = parseInt(optionIndexAttr.replace('option', ''), 10) - 1;
        if (isNaN(optionIndex) || optionIndex < 0 || optionIndex === quantityOptionIndex) return;

        const value = variant.options[optionIndex];
        const input = wrapper.querySelector('input[type="radio"][data-option-value="' + CSS.escape(value) + '"]');
        if (input) input.checked = true;
      });
    }

    onChange() {
      this.syncCards();
    }

    onVariantChange(event) {
      if (event && event.detail && event.detail.__ckCorrection) return;
      this.syncCards();
      this.applyBundleVariantBehavior();
    }

    onProductInfoLoaded() {
      const bundle = this.computeBundleAvailability();
      if (bundle) this.applyAvailabilityOverride(bundle);
    }

    applyBundleVariantBehavior() {
      const quantityInputs = Array.from(this.variantRadios.querySelectorAll('input.ck-quantity-variant-input'));
      if (!quantityInputs.length || !this.form) return;

      const checkedInput = quantityInputs.find((input) => input.checked);
      if (!checkedInput) return;

      const firstCard = this.variantRadios.querySelector('.ck-quantity-variant-card[for="' + quantityInputs[0].id + '"]');
      if (!firstCard || firstCard.getAttribute('data-show-per-pair') !== 'false') return;

      const card = this.variantRadios.querySelector('.ck-quantity-variant-card[for="' + checkedInput.id + '"]');
      const itemsPerPackage = (card ? parseInt(card.getAttribute('data-items-per-package') || '1', 10) : 1) || 1;

      const state = this.getOptionState();
      const firstQtyValue = quantityInputs[0] ? quantityInputs[0].value : null;
      const targetVariant = firstQtyValue
        ? this.findVariantForCard(firstQtyValue, state.selectedOptions, state.quantityOptionIndex)
        : this.variantData[0];
      if (!targetVariant) return;

      const idInput = this.form.querySelector('input[name="id"]');
      if (idInput) idInput.value = targetVariant.id;

      if (this.variantRadios.dataset.updateUrl !== 'false' && this.variantRadios.dataset.url) {
        window.history.replaceState({}, '', this.variantRadios.dataset.url + '?variant=' + targetVariant.id);
      }

      let qtyInput = this.form.querySelector('input[name="quantity"][data-ck-bundle-qty]');
      if (!qtyInput) {
        qtyInput = document.createElement('input');
        qtyInput.type = 'hidden';
        qtyInput.name = 'quantity';
        qtyInput.setAttribute('data-ck-bundle-qty', '');
        this.form.appendChild(qtyInput);
      }
      qtyInput.value = String(itemsPerPackage);

      const bundle = this.computeBundleAvailability();
      if (bundle) this.applyAvailabilityOverride(bundle);
    }

    computeBundleAvailability() {
      const quantityInputs = Array.from(this.variantRadios.querySelectorAll('input.ck-quantity-variant-input'));
      if (!quantityInputs.length || !this.form) return null;

      const checkedInput = quantityInputs.find((input) => input.checked);
      if (!checkedInput) return null;

      const firstCard = this.variantRadios.querySelector('.ck-quantity-variant-card[for="' + quantityInputs[0].id + '"]');
      if (!firstCard || firstCard.getAttribute('data-show-per-pair') !== 'false') return null;

      const card = this.variantRadios.querySelector('.ck-quantity-variant-card[for="' + checkedInput.id + '"]');
      if (!card || card.getAttribute('data-show-per-pair') !== 'true') return null;

      const itemsPerPackage = parseInt(card.getAttribute('data-items-per-package') || '1', 10) || 1;

      const state = this.getOptionState();
      const firstQtyValue = quantityInputs[0].value;
      const singleVariant = this.findVariantForCard(firstQtyValue, state.selectedOptions, state.quantityOptionIndex);
      if (!singleVariant) return null;

      let available;
      if (singleVariant.inventory_management === 'shopify' && this.inventoryData) {
        const singleQty = Number(this.inventoryData[String(singleVariant.id)]) || 0;
        available = singleQty >= itemsPerPackage;
      } else {
        available = !!singleVariant.available;
      }

      return { singleVariant, available };
    }

    dispatchCorrectedVariantChange(available) {
      const quantityInputs = Array.from(this.variantRadios.querySelectorAll('input.ck-quantity-variant-input'));
      const checkedInput = quantityInputs.find((input) => input.checked);
      if (!checkedInput || !this.form) return;

      const state = this.getOptionState();
      const currentVariant = this.findVariantForCard(checkedInput.value, state.selectedOptions, state.quantityOptionIndex);
      if (!currentVariant) return;

      const patchedVariant = Object.assign({}, currentVariant, { available });
      this.form.dispatchEvent(
        new CustomEvent('variant:change', { detail: { variant: patchedVariant, __ckCorrection: true } })
      );
    }

    applyAvailabilityOverride(bundle) {
      const { singleVariant, available } = bundle;

      this.dispatchCorrectedVariantChange(available);

      const buyButton = this.form.querySelector('[name="add"]');
      if (buyButton) {
        buyButton.classList.remove('d-none');
        if (available) {
          buyButton.removeAttribute('disabled');
        } else {
          buyButton.setAttribute('disabled', '');
        }
      }

      const deliverySold = document.querySelector('.prodBuyboxDeliverySold');
      if (deliverySold) deliverySold.classList.add('d-none');

      const url = this.variantRadios.dataset.url;
      const sectionId = this.variantRadios.dataset.section;
      if (!url || !sectionId) return;

      fetch(url + '?variant=' + singleVariant.id + '&section_id=' + sectionId)
        .then((response) => response.text())
        .then((responseText) => {
          const doc = new DOMParser().parseFromString(responseText, 'text/html');
          this.swapInventoryStatus(doc, sectionId);
          this.swapElementById(doc, 'ck-variant-delivery-' + sectionId);
        });
    }

    swapInventoryStatus(sourceDoc, sectionId) {
      const id = 'Inventory-' + sectionId;
      const source = sourceDoc.getElementById(id);
      const target = document.getElementById(id);
      if (!source || !target) return;

      if (source.querySelector('progress-bar')) {
        target.classList.add('d-none');
        return;
      }

      target.outerHTML = source.outerHTML;
    }

    swapElementById(sourceDoc, id) {
      const source = sourceDoc.getElementById(id);
      const target = document.getElementById(id);
      if (source && target) target.outerHTML = source.outerHTML;
    }

    getMoneyFormatter() {
      const currencyCode = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
      const locale = document.documentElement.lang || 'de-DE';

      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: currencyCode,
        });
      } catch (error) {
        return new Intl.NumberFormat('de-DE', {
          style: 'currency',
          currency: 'EUR',
        });
      }
    }

    formatCents(cents) {
      const formatter = this.moneyFormatter || (this.moneyFormatter = this.getMoneyFormatter());
      return formatter.format((Number(cents) || 0) / 100);
    }

    getItemsPerPackage(input, card, variant) {
      const fromInput = parseInt((input && input.value ? input.value : '').toString().replace(/[^\d]/g, ''), 10);
      if (!isNaN(fromInput) && fromInput > 0) return fromInput;

      const fromDataAttr = parseInt(card.getAttribute('data-items-per-package') || '', 10);
      if (!isNaN(fromDataAttr) && fromDataAttr > 0) return fromDataAttr;

      if (variant && Array.isArray(variant.options)) {
        const fromVariantOption = parseInt((variant.options.join(' ') || '').replace(/[^\d]/g, ''), 10);
        if (!isNaN(fromVariantOption) && fromVariantOption > 0) return fromVariantOption;
      }

      return 1;
    }

    getOptionState() {
      const optionWrappers = Array.from(this.variantRadios.querySelectorAll('.variant-input-wrapper'));
      const selectedOptions = [];
      let quantityOptionIndex = -1;
      let quantityInputs = [];

      optionWrappers.forEach((wrapper) => {
        const optionIndexAttr = wrapper.getAttribute('data-option-index') || '';
        const optionIndex = parseInt(optionIndexAttr.replace('option', ''), 10) - 1;
        if (isNaN(optionIndex) || optionIndex < 0) return;

        const selectedInput = wrapper.querySelector('input[type="radio"]:checked');
        selectedOptions[optionIndex] = selectedInput ? selectedInput.value : null;

        const wrapperQuantityInputs = Array.from(wrapper.querySelectorAll('input.ck-quantity-variant-input'));
        if (wrapperQuantityInputs.length) {
          quantityOptionIndex = optionIndex;
          quantityInputs = wrapperQuantityInputs;
        }
      });

      return {
        selectedOptions,
        quantityOptionIndex,
        quantityInputs,
      };
    }

    findVariantForCard(quantityValue, selectedOptions, quantityOptionIndex) {
      const matchedVariant = this.variantData.find((variant) => {
        if (!variant || !Array.isArray(variant.options)) return false;

        return variant.options.every((optionValue, optionIndex) => {
          if (optionIndex === quantityOptionIndex) {
            return optionValue === quantityValue;
          }
          return selectedOptions[optionIndex] == null || optionValue === selectedOptions[optionIndex];
        });
      });
      return matchedVariant || null;
    }

    isVariantInStock(variant) {
      if (!variant) return false;
      if (variant.inventory_management === 'shopify' && variant.inventory_policy === 'deny') {
        return Number(variant.inventory_quantity) > 0;
      }
      return !!variant.available;
    }

    getItemsPerPackageForQuantityValue(quantityValue) {
      const input = this.variantRadios.querySelector(
        '.ck-quantity-variant-input[value="' + CSS.escape(quantityValue) + '"]'
      );
      const card = input
        ? this.variantRadios.querySelector('.ck-quantity-variant-card[for="' + input.id + '"]')
        : null;
      const itemsPerPackage = card ? parseInt(card.getAttribute('data-items-per-package') || '1', 10) : 1;
      return itemsPerPackage > 0 ? itemsPerPackage : 1;
    }

    isVariantAvailableForBundle(variant, bundleContext) {
      if (!bundleContext || !bundleContext.isTypeA || bundleContext.quantityOptionIndex < 0) {
        return this.isVariantInStock(variant);
      }

      const { quantityOptionIndex, firstQtyValue } = bundleContext;
      if (!firstQtyValue || variant.options[quantityOptionIndex] === firstQtyValue) {
        return this.isVariantInStock(variant);
      }

      const singleVariant = this.findVariantForCard(firstQtyValue, variant.options, quantityOptionIndex);
      if (!singleVariant) return this.isVariantInStock(variant);

      if (singleVariant.inventory_management === 'shopify' && this.inventoryData) {
        const singleQty = Number(this.inventoryData[String(singleVariant.id)]) || 0;
        const itemsNeeded = this.getItemsPerPackageForQuantityValue(variant.options[quantityOptionIndex]);
        return singleQty >= itemsNeeded;
      }

      return this.isVariantInStock(singleVariant);
    }

    hasInStockVariantForInput(optionIndex, optionValue, selectedOptions, bundleContext) {
      return this.variantData.some((variant) => {
        if (!variant || !Array.isArray(variant.options)) return false;

        const matchesOptions = variant.options.every((variantOptionValue, variantOptionIndex) => {
          if (variantOptionIndex === optionIndex) {
            return variantOptionValue === optionValue;
          }
          const selectedValue = selectedOptions[variantOptionIndex];
          return selectedValue == null || variantOptionValue === selectedValue;
        });
        if (!matchesOptions) return false;

        return this.isVariantAvailableForBundle(variant, bundleContext);
      });
    }

    updateOptionInputStates(state) {
      const { selectedOptions, quantityOptionIndex, quantityInputs } = state;
      const firstCard = quantityInputs.length
        ? this.variantRadios.querySelector('.ck-quantity-variant-card[for="' + quantityInputs[0].id + '"]')
        : null;
      const bundleContext = {
        isTypeA: !!(firstCard && firstCard.getAttribute('data-show-per-pair') === 'false'),
        quantityOptionIndex,
        firstQtyValue: quantityInputs[0] ? quantityInputs[0].value : null,
      };

      const optionWrappers = Array.from(this.variantRadios.querySelectorAll('.variant-input-wrapper'));

      optionWrappers.forEach((wrapper) => {
        const optionIndexAttr = wrapper.getAttribute('data-option-index') || '';
        const optionIndex = parseInt(optionIndexAttr.replace('option', ''), 10) - 1;
        if (isNaN(optionIndex) || optionIndex < 0) return;

        const optionInputs = Array.from(wrapper.querySelectorAll('input[type="radio"][data-option-value]'));
        optionInputs.forEach((input) => {
          const inStock = this.hasInStockVariantForInput(optionIndex, input.value, selectedOptions, bundleContext);
          if (inStock) {
            input.classList.remove('disabled');
          } else {
            input.classList.add('disabled');
          }
        });
      });
    }

    updateCardImage(input, variant) {
      if (!input || !variant) return;

      const card = this.variantRadios.querySelector('.ck-quantity-variant-card[for="' + input.id + '"]');
      if (!card) return;

      const image = card.querySelector('.ck-quantity-variant-card__image');
      if (!image) return;

      const featuredImage = variant.featured_image || null;
      const source = featuredImage && featuredImage.src ? featuredImage.src : '';
      if (!source) return;

      image.src = withImageWidth(source, 220);
      image.removeAttribute('srcset');
      image.alt = variant.title || input.value;
    }

    updateCardPricing(input, variant) {
      if (!input || !variant) return;

      const card = this.variantRadios.querySelector('.ck-quantity-variant-card[for="' + input.id + '"]');
      if (!card) return;

      const pricesEl = card.querySelector('.ck-quantity-variant-card__prices');
      const priceEl = card.querySelector('.ck-quantity-variant-card__price');
      let compareEl = card.querySelector('.ck-quantity-variant-card__compare');
      const saveAmountEl = card.querySelector('.ck-quantity-variant-card__save-amount');
      let discountEl = card.querySelector('.ck-quantity-variant-card__discount');
      const saveRowEl = card.querySelector('.ck-quantity-variant-card__save-row');
      const showPerPair = card.getAttribute('data-show-per-pair') === 'true';

      if (!compareEl && pricesEl) {
        compareEl = document.createElement('span');
        compareEl.className = 'ck-quantity-variant-card__compare';
        pricesEl.prepend(compareEl);
      }

      if (!discountEl && saveRowEl && showPerPair) {
        discountEl = document.createElement('span');
        discountEl.className = 'ck-quantity-variant-card__discount';
        saveRowEl.appendChild(discountEl);
      }

      if (priceEl) {
        priceEl.textContent = this.formatCents(variant.price);
      }

      const compareAt = Number(variant.compare_at_price) || 0;
      const price = Number(variant.price) || 0;
      const hasDiscount = compareAt > price;

      if (compareEl) {
        if (hasDiscount) {
          compareEl.textContent = this.formatCents(compareAt);
          compareEl.style.display = '';
        } else {
          compareEl.textContent = '';
          compareEl.style.display = 'none';
        }
      }

      if (discountEl) {
        if (hasDiscount) {
          const discountPercent = Math.round(((compareAt - price) * 100) / compareAt);
          discountEl.textContent = '-' + discountPercent + '%';
          discountEl.style.display = '';
        } else {
          discountEl.textContent = '';
          discountEl.style.display = 'none';
        }
      }

      if (saveAmountEl && showPerPair) {
        const itemsPerPackage = this.getItemsPerPackage(input, card, variant);
        const perPackagePrice = itemsPerPackage > 0 ? Math.round(price / itemsPerPackage) : price;
        const unitLabel = card.getAttribute('data-unit-label') || 'Stück';
        saveAmountEl.textContent = this.formatCents(perPackagePrice) + '/ ' + unitLabel;
      }

      if (saveRowEl) {
        saveRowEl.style.display = showPerPair ? '' : 'none';
      }
    }

    updateCardState(input, variant) {
      const card = this.variantRadios.querySelector('.ck-quantity-variant-card[for="' + input.id + '"]');
      if (!variant) {
        if (input) {
          input.classList.add('disabled');
          input.disabled = true;
        }
        if (card) card.classList.add('disabled');
        return;
      }

      let available;
      const quantityInputs = Array.from(this.variantRadios.querySelectorAll('input.ck-quantity-variant-input'));
      const firstCard = quantityInputs.length
        ? this.variantRadios.querySelector('.ck-quantity-variant-card[for="' + quantityInputs[0].id + '"]')
        : null;
      const isTypeA = firstCard && firstCard.getAttribute('data-show-per-pair') === 'false';

      if (isTypeA && this.inventoryData && card && card.getAttribute('data-show-per-pair') !== 'false') {

        const state = this.getOptionState();
        const firstQtyValue = quantityInputs[0] ? quantityInputs[0].value : null;
        const singleVariant = firstQtyValue
          ? this.variantData.find((v) => {
              if (!v || !Array.isArray(v.options)) return false;
              return v.options.every((val, idx) => {
                if (idx === state.quantityOptionIndex) return val === firstQtyValue;
                return state.selectedOptions[idx] == null || val === state.selectedOptions[idx];
              });
            })
          : null;

        if (singleVariant && singleVariant.inventory_management === 'shopify') {
          const singleQty = Number(this.inventoryData[String(singleVariant.id)]) || 0;
          const itemsNeeded = parseInt(card.getAttribute('data-items-per-package') || '1', 10) || 1;
          available = singleQty >= itemsNeeded;
        } else {
          available = singleVariant ? !!singleVariant.available : !!variant.available;
        }
      } else {
        available = !!variant.available;
      }

      if (available) {
        if (input) {
          input.classList.remove('disabled');
          input.disabled = false;
        }
        if (card) card.classList.remove('disabled');
      } else {
        if (input) {
          input.classList.add('disabled');
          input.disabled = true;
        }
        if (card) card.classList.add('disabled');
      }
    }

    syncCards() {
      const state = this.getOptionState();
      if (state.quantityOptionIndex < 0 || !state.quantityInputs.length) return;

      this.updateOptionInputStates(state);

      state.quantityInputs.forEach((input) => {
        const variant = this.findVariantForCard(input.value, state.selectedOptions, state.quantityOptionIndex);
        this.updateCardImage(input, variant);
        this.updateCardPricing(input, variant);
        this.updateCardState(input, variant);
      });
    }
  }

  function initCkQuantityVariantCards(root) {
    const context = root || document;
    const variantRadiosList = context.querySelectorAll('variant-radios');
    variantRadiosList.forEach((variantRadios) => {
      if (variantRadios.__ckQuantityVariantCardsInitialized) return;
      variantRadios.__ckQuantityVariantCardsInitialized = true;

      const instance = new CkQuantityVariantCards(variantRadios);
      instance.init();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCkQuantityVariantCards(document);
    });
  } else {
    initCkQuantityVariantCards(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initCkQuantityVariantCards(event.target);
  });
})();
